import React, { PureComponent } from 'react'
import { Link } from 'react-router'
import moment from 'moment'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, branch, renderComponent } from 'recompose'
import { ProgressiveLoader } from '@driftt/tide-core-legacy'

import * as SegmentActions from 'app/modules/segment/actions'
import * as SegmentSelectors from 'app/modules/segment/selectors'
import * as EndUserSelector from 'app/modules/endUser/selectors'
import { track } from 'app/modules/tracking/actions'

import Header from 'components/customer/CompanyCard/Header'
import {
  PLACEHOLDER_PRIMARY_COLOR,
  PLACEHOLDER_SECONDARY_COLOR,
  PLACEHOLDER_PRIMARY_OPACITY,
  PLACEHOLDER_SECONDARY_OPACITY,
} from 'components/conversation/ContactSideBar'
import { segmentsCardPlaceholder } from './style.styl'

const Icon = (
  <img
    src={require('images/svg/segment-navy.svg')}
    style={{ width: 12, height: 12, marginRight: 6 }}
  />
)

const SegmentsCardPlaceholder = () => {
  const placeholderShape = [
    <rect key={0} x="0" y="0" width="229" height="27" rx="2"></rect>,
    <rect key={1} x="0" y="47" width="229" height="27" rx="2"></rect>,
    <rect key={2} x="0" y="94" width="229" height="27" rx="2"></rect>,
  ]

  const options = {
    height: 131,
    width: 229,
    primaryColor: PLACEHOLDER_PRIMARY_COLOR,
    secondaryColor: PLACEHOLDER_SECONDARY_COLOR,
    primaryOpacity: PLACEHOLDER_PRIMARY_OPACITY,
    secondaryOpacity: PLACEHOLDER_SECONDARY_OPACITY,
  }

  return (
    <div className={segmentsCardPlaceholder}>
      <ProgressiveLoader options={options} placeholderShape={placeholderShape} numPlaceholders={1} />
    </div>
  )
}

const Segment = props => {
  const {
    segment: {
      id, name, createdAt
    },
    className
  } = props
  return (
    <div key={id} style={{ padding: '5 20px' }} className={className}>
      <Link
        to={{
          pathname: `/contacts/segments/${id}`
        }}
        onClick={() => track('Conversation Sidebar - Segment Clicked')}
      >
        <div className="dsg-Body">{name}</div>
      </Link>
      <div className="dsg-Regular color-navy-dark">
        Added {moment(createdAt).format('M/D/YY')}
      </div>
    </div>
  )
}

class SegmentsCard extends PureComponent {
  componentDidMount() {
    if (!this.props.segmentListLoaded) {
      this.props.actions.fetchSegmentList()
    }
    if (!this.props.endUserSegmentsLoaded) {
      this.props.actions.fetchEndUserMembership({ endUserId: this.props.endUserId })
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.endUser !== nextProps.endUser) {
      this.props.actions.fetchEndUserMembership({ endUserId: nextProps.endUserId })
    }
  }
  render() {
    const { endUserSegments } = this.props
    return (
      <div className={classnames('dsg-card', this.props.className)} style={{ marginBottom: '1rem' }}>
        <Header
          label="segments"
          icon={Icon}
        />
        <div style={{ padding: '20px 0' }}>
          {endUserSegments.valueSeq()
            .map(segment => <Segment key={segment.id} segment={segment} className={this.props.segmentClassName}/>)}
        </div>
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const endUserSelector = EndUserSelector.makeEndUserSelector()
  return (state, props) => {
    const { endUserId } = props
    return {
      endUserSegments: SegmentSelectors.endUserSegments(state, { endUserId }),
      endUserSegmentsLoaded: SegmentSelectors.endUserMembershipByIdFetched(state, { endUserId }),
      segmentListLoaded: SegmentSelectors.segmentListLoaded(state, { endUserId }),
      endUser: endUserSelector(state, { id: props.endUserId }),
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        fetchEndUserMembership: SegmentActions.fetchEndUserMembership,
        fetchSegmentList: SegmentActions.fetchSegmentList,
      },
      dispatch
    ),
  }
}

export default compose(
  connect(makeMapStateToProps, mapDispatchToProps),
  branch(
    props => !props.endUserId,
    renderComponent(SegmentsCardPlaceholder),
  )
)(SegmentsCard)



// WEBPACK FOOTER //
// ./src/scripts/components/customer/SegmentsCard/index.js